<template>
    <div class="container" id="container">

        <!-- Buttin Back  -->
        <div class="btn-back">
            <button @click="goBack()" class="btn btn--white">
                <svg class="mr-2 display-table-cell" width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 0.594098V8.22252C5 8.75074 4.36135 9.01526 3.98785 8.64176L0.173647 4.82755C-0.0578822 4.59602 -0.0578822 4.2206 0.173647 3.98907L3.98785 0.174856C4.36135 -0.198674 5 0.06588 5 0.594098Z" fill="#52749C"/></svg>
                <span>Back</span>
            </button>
        </div>

        <!-- Header -->
        <div v-if="!loading && details && details.name" class="launchpad__header display-table mb-4 w-100 position-relative">
          <svg class="launchpad__header--icon display-table-cell" width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.8393 0.5625C6.19596 0.5625 0 6.8584 0 14.625C0 17.2031 0.684756 19.6182 1.87695 21.6953C2.14653 22.165 2.66022 22.4375 3.19553 22.4375H24.483C25.0184 22.4375 25.532 22.165 25.8016 21.6953C26.9938 19.6182 27.6786 17.2031 27.6786 14.625C27.6786 6.8584 21.4826 0.5625 13.8393 0.5625ZM21.6815 9.07861L16.4654 16.1455C16.7446 16.6157 16.9147 17.1606 16.9147 17.75C16.9147 18.3223 16.7523 18.8511 16.488 19.3125H11.1906C10.9263 18.8511 10.7639 18.3223 10.7639 17.75C10.7639 16.0239 12.1406 14.625 13.8393 14.625C14.1108 14.625 14.3688 14.6719 14.6197 14.7393L19.8363 7.67139C20.2198 7.15576 20.9415 7.05029 21.4514 7.43701C21.9603 7.82568 22.064 8.56055 21.6815 9.07861Z" fill="#2B4D75"/>
          </svg>
          <div class="ml-2 launchpad__header--title display-table-cell">
              <h1 v-if="details && details.name" class="m-0 header">{{details.name}}</h1>
          </div>
        </div>

        <!-- Page Body -->
        <!--  -->
        <div v-if="!loading && details" class="row no-gutters" style="margin: 0 -7.5px;">

          <div class="col-md-4" style="padding: 0 7.5px;">
            <div class="row no-gutters" style="margin: 0 -7.5px;">

              <!-- Account -->
              <div class="col-md-12" style="padding: 0 7.5px;">
                <s-card>
                  <s-card-header class="font-weight-bold"> Account </s-card-header>
                  <s-card-body v-if="details && details.id">
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">ID</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{details.id}}</span>
                      </div>
                    </div>
                    <div :tooltip="details.name" class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Name</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{details.name}}</span>
                      </div>
                    </div>
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Joined</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{fromNow(details.created_at)}}</span>
                      </div>
                    </div>
                    <div class="reviews__campaign--row display-table w-100 mb-1">
                      <span class="display-table-cell text-secondary pr-2 white-space-nowrap">Last Active</span>
                      <div class="display-table-cell text-right w-100 text-truncate ">
                        <span class="font-weight-bold">{{fromNow(details.updated_at)}}</span>
                      </div>
                    </div>
                  </s-card-body>
                  <s-card-body v-else> Loading || No Data </s-card-body>
                  <s-card-footer v-if="details && details.id">
                    <button v-if="!loadingLoginAccount" @click="loginAffiliate()" class="btn btn--white w-100">Log in as this Affiliate</button>
                    <button v-else class="btn btn--white w-100 disabled"><s-loader type="scalify"></s-loader></button>
                  </s-card-footer>
                </s-card>
              </div>

            </div>

          </div>
          <div class="col-md-8" style="padding: 0 7.5px;">

            <!-- List Payouts -->
            <div id="products-table">
              <s-card class="products-table__card border-top-0 p-0">
                <s-card-header class="font-weight-bold"> Payouts </s-card-header>
                <!-- -->
                <s-card-body v-if="details && details.payouts && details.payouts.length > 0 " class="product-table__table p-0">
                    <div class="product-table__table-container" style="overflow: auto !important; max-height: 550px;">
                        <table  class="product-table__table--table" style="width: max-content;" id="myTable">
                            <thead class="product-table__table--header border-0 p-0 mb-4">
                                <!-- ID -->
                                <td class="text-truncate product-table__table--header-id">
                                    <span>ID</span>
                                </td>
                                <!-- status -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Status</span>
                                </td>
                                <!-- from -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>From</span>
                                </td>
                                <!-- to -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>To</span>
                                </td>
                                <!-- paid on -->
                                <td class="text-truncate product-table__table--header-joined">
                                    <span>Paid on</span>
                                </td>
                                <!-- Details -->
                                <td class="text-truncate product-table__table--header-joined">
                                  <span>Details</span>
                                </td>
                            </thead>
                            <tbody class="product-table__table--body">
                                <tr v-for="(payout, payoutIndex) in details.payouts" :key="payoutIndex" class="product-table__table--row">
                                    <!-- ID -->
                                    <td class="product-table__table--body-id">
                                      <p class="text-truncate">{{payout.id}}</p>
                                    </td>
                                    <!-- Status -->
                                    <td class="product-table__table--body-joined">
                                      <!-- <p class="text-truncate">{{payout.status}}</p> -->
                                      <s-badge class="badge badge--success" v-if="payout.status == 'PAID'">{{payout.status}}</s-badge>
                                      <s-badge class="badge badge--primary" v-else>{{payout.status}}</s-badge>
                                    </td>
                                    <!-- from -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{payout.from ? fromNow(payout.from) : '-'}}</p>
                                    </td>
                                    <!-- to -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{payout.to ? fromNow(payout.to) : '-'}}</p>
                                    </td>
                                    <!-- paid on -->
                                    <td class="product-table__table--body-joined">
                                      <p class="text-truncate">{{payout.paid_on ? fromNow(payout.paid_on) : '-'}}</p>
                                    </td>
                                    <!-- Details -->
                                    <td class="product-table__table--body-joined">
                                      <button v-if="!loadingPayoutDetails" @click.stop="detailsPayout(payout.id, payoutIndex)" class="btn btn--primary">
                                        <span >Details</span>
                                      </button>
                                      <button v-else  class="btn btn--primary disabled">
                                        <span >Details</span>
                                      </button>
                                    </td>

                                    <!-- Mark as Paid -->
                                    <!-- <td class="product-table__table--body-joined">
                                        <button :class="loadingSetAsPaid[payoutIndex] ? 'disabled' : ''" @click.stop="makeAsPaid(payout,payoutIndex)" class="btn btn--success" v-if="payout.status == 'UPCOMING'">
                                          <span v-if="!loadingSetAsPaid[payoutIndex]">Make as Paid</span>
                                          <s-loader :isWhite="true" v-else></s-loader>
                                        </button>
                                        <p class="text-truncate text-center" v-else>-</p>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </s-card-body>
                <s-card-body v-else class="p-3 text-center font-weight-bold">
                  No Results
                </s-card-body>
              </s-card>
            </div>
          </div>

        </div>

        <div v-else class="text-center">
          <s-loader></s-loader>
        </div>

        <!-- Modal -->
        <div v-if="openModal" style="background: rgba(13, 35, 62, 0.94); height: 100%; width: 100%; position: fixed; top: 0; left: 0;z-index: 13;">
          <s-card style="width: 90%; position: absolute; transform: translate(-50%,-50%); left: 50%; top: 50%;">
            <s-card-header class="font-weight-bold position-relative">
              <span>Payout Details</span>
              <svg @click="closeModale()" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%); cursor: pointer;" width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="3.53552" width="5" height="40" rx="2.5" transform="rotate(-45 0 3.53552)" fill="#C6D9FF"/>
                <rect x="3.53564" y="31.8198" width="5" height="40" rx="2.5" transform="rotate(-135 3.53564 31.8198)" fill="#C6D9FF"/>
              </svg>

            </s-card-header>
            <s-card-body class="p-3">

              <!-- Payout -->
              <div id="products-table">
                <s-card class="products-table__card border-top-0 p-0">
                  <s-card-body class="product-table__table p-0">
                    <div class="product-table__table-container" style="overflow: auto !important;max-height: 450px;">
                      <div class="div-shadow-left" v-if="modalData && modalData.charger && modalData.charger.length"></div>
                      <!-- modalData && modalData.length &&  -->
                      <table v-if="!loading" class="product-table__table--table" style="width: 1630px;" id="myTable">
                          <thead class="product-table__table--header border-0 p-0 mb-4">
                              <!-- ID -->
                              <td class="text-truncate product-table__table--header-id">
                                  <span>ID</span>
                              </td>
                              <!-- Charge ID -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Charge ID</span>
                              </td>
                              <!-- Customer ID -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Customer ID</span>
                              </td>
                              <!-- Subscription ID -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Subscription ID</span>
                              </td>
                              <!-- Start Date -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Start Date</span>
                              </td>
                              <!-- End Date -->
                              <td class="text-truncate product-table__table--header-trail-started">
                                  <span>End Date</span>
                              </td>
                              <!-- Payement Status -->
                              <td class="text-truncate product-table__table--header-trail-started">
                                  <span>Payement Status</span>
                              </td>
                              <!-- Aff Commission -->
                              <td class="text-truncate product-table__table--header-trail-started">
                                  <span>Commission</span>
                              </td>
                              <!-- Scalify Amount -->
                              <td class="text-truncate product-table__table--header-trail-started">
                                  <span>Scalify Amount</span>
                              </td>
                              <!-- Payment Type -->
                              <td class="text-truncate product-table__table--header-trail-started">
                                  <span>Payment Type</span>
                              </td>
                          </thead>
                          <tbody class="product-table__table--body">
                              <tr  v-show="!loading" v-for="(data, index) in modalData.charges" :key="index" class="product-table__table--row w-100">
                                  <!-- ID -->
                                  <td  class="display-table-cell product-table__table--body-id">
                                    <p class="text-truncate">{{data.id}}</p>
                                  </td>
                                  <!-- Charge ID -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                    <p  class="text-truncate">{{data.charge_id}}</p>
                                  </td>
                                  <!-- Customer ID -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                    <p  class="text-truncate">{{data.customer_id}}</p>
                                  </td>
                                  <!-- Subscription ID -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                    <p  class="text-truncate">{{data.subscription_id}}</p>
                                  </td>
                                  <!-- Start Date -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                    <p  class="text-truncate">{{data.start_date?data.start_date:''}}</p>
                                  </td>
                                  <!-- End Date -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                      <p class="text-truncate">{{data.end_date?data.end_date:''}}</p>
                                  </td>
                                  <!-- Payement Status -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                    <s-badge v-if="data.payment_status == 'succeeded'" class="badge badge--success">{{data.payment_status}}</s-badge>
                                    <s-badge v-if="data.payment_status == 'refunded' || data.payment_status == 'failed' || data.payment_status == 'expired'" class="badge badge--danger">{{data.payment_status}}</s-badge>
                                    <s-badge v-if="data.payment_status == 'pending'" class="badge badge--warning">{{data.payment_status}}</s-badge>
                                  </td>
                                  <!-- Aff Commission -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                      <p class="text-truncate">${{new Intl.NumberFormat('en-IN').format(data.aff_commission)}}</p>
                                  </td>
                                  <!-- Scalify Amount -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                      <p class="text-truncate">${{new Intl.NumberFormat('en-IN').format(data.amount)}}</p>
                                  </td>
                                  <!-- Payment Type -->
                                  <td class="display-table-cell product-table__table--body-trail-started">
                                      <p class="text-truncate">{{data.payment_type}}</p>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <div class="div-shadow-right" v-if="(modalData && modalData.length)"></div>
                    </div>
                  </s-card-body>
                  <s-card-footer class="row">
                    <p class="font-weight-bold col-6 display-table w-100" style="height: 40px;">
                      <span class="display-table-cell">Total Scalify Commissions:</span>
                      <span class="pl-2 display-table-cell text-success">${{new Intl.NumberFormat('en-IN').format(modalData.scalifyCommissions)}}</span>
                    </p>

                    <p class="font-weight-bold col-6 display-table w-100" style="height: 40px;">
                      <span class="display-table-cell">Total Affiliate Commissions: </span>
                      <span class="pl-2 display-table-cell text-success">${{new Intl.NumberFormat('en-IN').format(modalData.affiliateCommissions)}}</span>
                      <span v-if="details && details.settings && details.settings.dept" class="pl-2 display-table-cell text-danger">- ${{new Intl.NumberFormat('en-IN').format(details.settings.dept)}}</span>
                      </p>

                    <p v-if="details && details.settings && details.settings.dept" class="font-weight-bold col-6 display-table w-100" style="height: 40px;">
                      <span class="display-table-cell">Total Dept: </span>
                      <span class="pl-2 display-table-cell text-danger">${{new Intl.NumberFormat('en-IN').format(finalDept)}}</span>
                    </p>

                    <p v-if="details.payouts[this.currentPayoutIndex].status == 'UPCOMING'" class="font-weight-bold col-6 display-table w-100" style="height: 40px;">
                      <span class="display-table-cell">Total requested Amount: </span>
                      <s-input class="ml-2 display-table-cell" v-model="requestedAmount" type="number" fieldFor="currency" placeholder="Total requested Amount" currency="USD"></s-input>
                      <svg class="display-table-cell ml-2 cursor-pointer" @click="initialiseRequestAmount()" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.48624 1.21938e-05C5.48214 0.00361098 3.66251 0.793349 2.3191 2.07718L1.23904 0.997119C0.781784 0.539861 0 0.863692 0 1.51032V5.56453C0 5.96538 0.32495 6.29033 0.725806 6.29033H4.78001C5.42664 6.29033 5.75047 5.50855 5.29325 5.05129L4.03064 3.78869C4.96403 2.91473 6.1718 2.43062 7.45494 2.41955C10.2492 2.39542 12.6046 4.65676 12.5805 7.5438C12.5575 10.2825 10.3372 12.5807 7.5 12.5807C6.25624 12.5807 5.08074 12.1368 4.15433 11.3239C4.0109 11.1981 3.79427 11.2057 3.65933 11.3406L2.45988 12.5401C2.31254 12.6874 2.31983 12.9277 2.47446 13.0673C3.80437 14.2686 5.56675 15 7.5 15C11.6421 15 15 11.6422 15 7.50007C15 3.3627 11.6236 -0.00739708 7.48624 1.21938e-05Z" fill="#2B4D75"/>
                      </svg>

                      <!-- <span class="pl-2 display-table-cell">${{new Intl.NumberFormat('en-IN').format(modalData.amount)}}</span> -->
                    </p>

                    <div class="col-6 display-table w-100" style="height: 40px;">
                      <button :class="loadingSetAsPaid ? 'disabled' : ''" @click.stop="makeAsPaid()" class="btn btn--success display-table-cell" v-if="this.details.payouts[this.currentPayoutIndex].status == 'UPCOMING'">
                      <span v-if="!loadingSetAsPaid">Make as Paid</span>
                      <s-loader :isWhite="true" v-else></s-loader>
                    </button>
                    </div>
                  </s-card-footer>
                </s-card>
              </div>

            </s-card-body>
          </s-card>
        </div>
    </div>
</template>

<script>

// import moment from 'moment';

export default {

  name: 'Affiliate-Details',

    components: {

    },

    data(){
      return{
        details:null,
        loading: false,
        loadingSetAsPaid: false,
        modalData: null,
        openModal: false,
        loadingLoginAccount: false,
        loadingPayoutDetails: false,
        currentPayoutIndex: null,
        requestedAmount: 0,
        finalDept: 0
      };
    },
    async mounted(){

      if (this.$route.params && this.$route.params.id) {
        this.loading = true;
        const getDetails = await this.getData(`${this.api}/api/admin/affiliate/${this.$route.params.id}/details`);
        // console.log('getDetails: ', getDetails);
        if (getDetails && getDetails.id) {
          this.details = {...getDetails};
        }
        this.loading = false;
        this.$forceUpdate()

      }

    },
    created(){

    },
    watch:{

    },
    methods:{

      initialiseRequestAmount(){
        this.requestedAmount = this.modalData.amount - this.details.settings.dept >= 0 ? Number.parseFloat(this.modalData.amount - this.details.settings.dept).toFixed(2) : 0;
      },
      closeModale(){
        this.openModal = false
        this.currentPayoutIndex = null
        this.requestedAmount = 0
      },

      async detailsPayout(id, index){

        this.loadingPayoutDetails = true;
        const detailsPayout = await this.getData(`${this.api}/api/admin/affiliate/${this.details.id}/payout/${id}`);
        console.log('detailsPayout: ', detailsPayout);
        let scalifyCommissions = 0;
        let affiliateCommissions = 0;
        if (detailsPayout && detailsPayout.charges && detailsPayout.charges.length) {
          detailsPayout.charges.map((charge)=>{
            scalifyCommissions = scalifyCommissions + charge.amount
            affiliateCommissions = affiliateCommissions + charge.aff_commission
          })
        }
        this.requestedAmount = detailsPayout.amount - this.details.settings.dept >= 0 ? Number.parseFloat(detailsPayout.amount - this.details.settings.dept).toFixed(2) : 0;
        this.finalDept = detailsPayout.amount - this.details.settings.dept >= 0 ? 0 : Math.abs(Number.parseFloat(detailsPayout.amount - this.details.settings.dept).toFixed(2))
        this.modalData = detailsPayout;
        this.modalData.scalifyCommissions = scalifyCommissions;
        this.modalData.affiliateCommissions = affiliateCommissions;
        this.currentPayoutIndex = index;
        this.loadingPayoutDetails = false
        this.openModal = true
      },

      async makeAsPaid(){
        this.loadingSetAsPaid = true
        this.$forceUpdate()
        const data = {status : "PAID", paid_amount : this.requestedAmount, dept: this.finalDept}
        let setStatus = await this.postData(`${this.api}/api/admin/affiliate/${this.$route.params.id}/payout/${this.details.payouts[this.currentPayoutIndex].id}`, data);
        if(setStatus){
          this.details.payouts[this.currentPayoutIndex] = {...setStatus}
        }
        this.loadingSetAsPaid = false
        this.openModal = false
        // this.$forceUpdate()
      },

      goBack(){
        this.$router.push(`/affiliates`);
      },

      async loginAffiliate(){

        if(confirm("Do you really want to connect as this user?")){

          this.loadingLoginAccount = true;
          const loginAffiliate = await this.getData(`${this.api}/api/admin/affiliate/${this.details.id}/login-affiliate`);
          console.log('loginAffiliate: ', loginAffiliate);
          if (loginAffiliate && loginAffiliate.link) {

            window.open(loginAffiliate.link, '_blank');
          }else{
            this.notify("error","Something went wrong, please try again")
          }
          this.loadingLoginAccount = false

        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>